import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { PhoneIcon } from '@rsos/assets/icons';
import ChatAvatar from '@rsos/components/capstone/Chat/ChatAvatar';
import { Container, TitleBox, Title, Row, ParticipantInfo, ParticipantName, ParticipantDesc, PhoneNumber } from '@rsos/components/capstone/Chat/ChatParticipants/ChatParticipants.styles';


/**
 * Displays a Popover of current chat participants in the Text-From-911 chat.
 *
 * @param {array} participants - list of chat participants for Text-From-911
 * @param {object} theme - styled component theme object
 */
const TF911ChatParticipants = ({ participants }) => {
  const { display_name: currentPSAPDisplayName } = useSelector(
    state => state.psaps.currentPSAP,
  );

  return (
    <Container>
      <TitleBox>
        <Title>Participants</Title>
      </TitleBox>
      {participants &&
        participants.length > 0 &&
        participants.map((participant, idx) => (
          <Row key={idx}>
            {/* TODO: conditionals for the ECC user vs the chat participant */}
            <ChatAvatar name={participant.display_name} />
            <ParticipantInfo>
              <ParticipantName>{participant.display_name}</ParticipantName>
              {participant?.contact_phone && (
                <ParticipantDesc>
                  <PhoneIcon
                    width={10}
                    height={12}
                    viewboxWidth={11}
                    viewboxHeight={15}
                    color="secondaryText"
                  />
                  <PhoneNumber>{participant.contact_phone}</PhoneNumber>
                </ParticipantDesc>
              )}
            </ParticipantInfo>
          </Row>
        ))}
      <Row>
        <ChatAvatar name={currentPSAPDisplayName} />
        <ParticipantInfo>
          <ParticipantName>{currentPSAPDisplayName}</ParticipantName>
          <ParticipantDesc>Your Agency</ParticipantDesc>
        </ParticipantInfo>
      </Row>
    </Container>
  );
};

TF911ChatParticipants.propTypes = {
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      account_id: PropTypes.string,
      display_name: PropTypes.string,
      contact_phone: PropTypes.string,
    }),
  ),
};

export default TF911ChatParticipants;